module.exports = __webpack_public_path__ + "media/images/question_examples/question-example-single-0ff83a8096572df3841e69c5d7248939.png";